import { useMemo, useState } from "react";
import { Col, Collapse, Dropdown, DropdownButton, Row, Spinner } from "react-bootstrap";
import { axiosGetWithHeader } from "../../Common/axios";

export function TimeChart ({menuArray,userData,clientData,eventData,handleEventKey,handleEventData}) {
  const [spinner, setSpinner] = useState('Loading - Time Anayser');
  const [piltData, setPiltData] = useState([]);
  //const [supportCategory,setSupportCategory] = useState([0,0,0,0,0,0,0,0,0]);
  const loop = [1,2,3];
  const favorloop = ["Favorable","Mixed","Unfavorable"];
  const planetloop = ["Ket","Ven","Sun","Mon","Mar","Rag","Jup","Sat","Mer"];
  const planetOrderloop = [9,6,1,2,3,8,5,7,4];

  const [showfavorValue, setShowFavorValue] = useState(
    [
      [false,false,false,false],
      [false,false,false,false],
      [false,false,false,false]
    ]
  );
  const [showPlanetValue, setShowPlanetValue] = useState(
    [
      [false,false,false,false],
      [false,false,false,false],
      [false,false,false,false],
      [false,false,false,false],
      [false,false,false,false],
      [false,false,false,false],
      [false,false,false,false],
      [false,false,false,false],
      [false,false,false,false]
    ]
  );

  const handleEvents = (key)=> handleEventKey(key);

  useMemo(() => {
  /*  if(eventData!==null && eventData.userEvent!==null && eventData.userEvent.supportCategory!==null) {
      setSupportCategory(eventData.userEvent.supportCategory.split(","));
    } else {
      setSupportCategory([0,0,0,0,0,0,0,0,0]);
    } */
    if(userData===null||userData===undefined) {
      setSpinner(null);
      return;
    }
    if(eventData===null||eventData===undefined||eventData.currentEvent===null||eventData.currentEvent===undefined) {
      setSpinner(null);
      return;
    }
    var clientId = userData.id;
    var eventId = eventData.currentEvent.id;
    axiosGetWithHeader("/chart/piltchart/"+clientId+"/"+eventId,
      (response)=>{
        setPiltData(response.data);
        setSpinner(null);
      },
      (error)=>{
        console.log(error);
        setPiltData([]);
        setSpinner(null);
      }
    );

  }, [userData,eventData]);

  function handleChange(val1, val2,event) {
    const tempShowValue = [...showfavorValue];
    tempShowValue[val1][val2]=event.target.checked;
    setShowFavorValue(tempShowValue);
  }

  function handlePlanetChange(val1, val2,event) {
    const tempShowValue = [...showPlanetValue];
    tempShowValue[val1][val2]=event.target.checked;
    setShowPlanetValue(tempShowValue);
  }

  function getValue(planet, rowindex,colindex) {
    return planet===undefined||planet[rowindex]===undefined?"":planet[rowindex][colindex];
  }

  function getStyle(planet, rowindex) {
    if(planet===undefined||planet[rowindex]===undefined) {
      return {'background-color':'transparent'};
    }
    
    for(var i=0; i<favorloop.length;i++) {
      if ( (i===0&& planet[rowindex][1]>=1 && planet[rowindex][1]<=3) ||
            (i===1&& planet[rowindex][1]>=4 && planet[rowindex][1]<=6) ||
            (i===2&& planet[rowindex][1]>=7 && planet[rowindex][1]<=9) ) {
        if( showfavorValue[i][0]===true ||
            (rowindex===1 && showfavorValue[i][1]===true) ||
            (rowindex===2 && showfavorValue[i][2]===true) ||
            (rowindex>2 && showfavorValue[i][3]===true) 
        ) {
          return {'background-color':planet[rowindex][2], 'color':planet[rowindex][3]};
        } else if(rowindex===1 && showfavorValue[i][1]===true) {
            return {'background-color':planet[rowindex][2], 'color':planet[rowindex][3]};
        }
      }
    }

    for(i=0; i<planetloop.length;i++) {
      if(planet[rowindex][0].includes(planetloop[i])===false) continue;
      if(showPlanetValue[i][0]===true) {
        return {'background-color':planet[rowindex][2], 'color':planet[rowindex][3]};
      } else {
        if((rowindex===1 && showPlanetValue[i][1]===true) ||
           (rowindex===2 && showPlanetValue[i][2]===true) ||
           (rowindex>2 && showPlanetValue[i][3]===true) ) {
          return {'background-color':planet[rowindex][2], 'color':planet[rowindex][3]};
        }
      }
    }
    return {'background-color':'transparent'};
  }

  function handleClear() {
    const tempShowValue = [...showfavorValue];
    for(var i=0; i<3;i++) {
      document.getElementById("all"+i).checked=false;
      document.getElementById("PL"+i).checked=false;
      document.getElementById("SG"+i).checked=false;
      document.getElementById("SU"+i).checked=false;
      for(var j=0; j<4;j++) {
        tempShowValue[i][j]=false;
      }
    }
    setShowFavorValue(tempShowValue);
    const tempShowValue1 = [...showPlanetValue];
    for(i=0; i<9;i++) {
      document.getElementById("allp"+i).checked=false;
      document.getElementById("PLp"+i).checked=false;
      document.getElementById("SGp"+i).checked=false;
      document.getElementById("SUp"+i).checked=false;
      for(j=0; j<4;j++) {
        tempShowValue1[i][j]=false;
      }
    }
    setShowPlanetValue(tempShowValue1);
  }

  return(<>
    {spinner===null?<></>:<>{spinner} <Spinner animation="border" size="sm" /></>}
    { eventData===null || eventData===undefined || eventData.length===0 || userData===null || userData===undefined
          || clientData===null || clientData===undefined || piltData===null || piltData===undefined ?<></>:
      <Collapse in={menuArray[3]} className="m-0 p-0">
        <Row id="timeChart" className="m-0 p-0">
          <Col xs={12} className="p-0 m-0 pt-1">
          
            <Row id="timechart1" className="m-0 p-0">
              <Col xs={0} lg={3} className="m-0 p-0">
                <table class="table table-hover align-middle caption-top m-0 p-0 text-center TableFont11">
                  <caption class="m-0 p-0 ps-2 pt-2"><h5 class="m-0 p-0">Time Analyser</h5></caption>
                </table>
              </Col>
              <Col xs={12} lg={6} className="p-0 m-0 text-center">
                <Row id="heading" className="m-0 p-0">
                  <Col xs={0} lg={3} className="p-0 m-0 text-start">
                    <DropdownButton id="dropdown-basic-button" title={eventData.currentEvent.name} variant="light" class="m-0 p-0 me-2">
                      <div style={{ maxHeight: '250px', overflowY: 'auto' }}>
                      {Object.keys(eventData.allEvents).map((key, index) => {
                        const event = eventData.allEvents[key];
                        return Object.keys(event).map((key) => {
                          const value = event[key];
                          if(key<0) {
                            return <Dropdown.Divider/>
                          }
                          return <Dropdown.Item onClick={()=>handleEvents(key)} >{value}</Dropdown.Item>
                        })  
                      })}
                      </div>
                    </DropdownButton>
                  </Col>
                  <Col xs={0} lg={9} className="p-0 pt-0 m-0">
                  <div class="input-group m-0 p-0">
                    <input type="input" maxlength="10" class="form-control" title="Primary" value={eventData.currentEvent.primary===null?"":eventData.currentEvent.primary}/>
                    <input type="input" maxlength="10" class="form-control" title="Secondary" value={eventData.currentEvent.secondary===null?"":eventData.currentEvent.secondary}/>
                    <input type="input" maxlength="10" class="form-control" title="Supportive" value={eventData.currentEvent.supportive===null?"":eventData.currentEvent.supportive} />
                    <input type="input" maxlength="10" class="form-control" title="Bad" value={eventData.currentEvent.bad===null?"":eventData.currentEvent.bad}/>
                    <input type="input" maxlength="10" class="form-control" title="worse" value={eventData.currentEvent.worse===null?"":eventData.currentEvent.worse} />
                    <input type="input" maxlength="10" class="form-control" title="Worst" value={eventData.currentEvent.worst===null?"":eventData.currentEvent.worst} />
                  </div>
                  </Col>    
                </Row>
              </Col>
              <Col xs={0} lg={3} className="m-0 p-0 text-end">
              </Col>
            </Row>

            <Row id="timechart1" className="m-0 p-0">
              <Col xs={0} lg={9} className="m-0 p-0 text-center">
                      
                <Row id="time2" className="m-0 p-0 ">
                  <Col xs={12} lg={12} className="m-0 p-0 pt-1 pb-1">
                    <table class="table table-bordered table-hover align-middle caption-top m-0 p-0 text-center TableFont11">
                      <small class="Font12 ps-4" title={"Dasha Period   :"+clientData.currentDashaPeriod+"\nDasha Balance :"+clientData.currentDashaBalance}>
                        Dasha:{clientData.currentDashaName}({clientData.currentDashaStart.substring(0,10)} to {clientData.currentDashaEnd.substring(0,10)})
                      </small>
                      <small class="Font12 ps-2" title={"Bhukti Period   :"+clientData.currentBhuktiPeriod+"\nBhukti Balance :"+clientData.currentBhuktiBalance}>
                        Bhukti:{clientData.currentBhuktiName}({clientData.currentBhuktiStart.substring(0,10)} to {clientData.currentBhuktiEnd.substring(0,10)})
                      </small>
                      <small class="Font12 ps-2" title={"Andharam Period   :"+clientData.currentAndharamPeriod+"\nAndharam Balance :"+clientData.currentAndharamBalance}>
                        Andharam:{clientData.currentAndharamName}({clientData.currentAndharamStart.substring(0,10)} to {clientData.currentAndharamEnd.substring(0,10)})
                      </small>
                    </table>
                  </Col>
                </Row> 

                {loop.map((row, rowindex) => (
                <Row id="timechart2" className="m-0 p-0">
                  {loop.map((col, colindex) => (
                  <Col xs={12} lg={4} className="m-0 p-1 pb-2 text-center">
                    <table class="table table-bordered table-hover align-middle caption-top p-0 m-0 text-center TableFont11">
                      <thead>
                        <tr class="m-0 p-0" >
                          <th class="p-0 align-middle plittable-td bg-info-subtle">Element</th> 
                          <th class="p-0 align-middle plittable-td bg-info-subtle">Planet</th> 
                          <th class="p-0 align-middle plittable-td bg-info-subtle">Sign</th> 
                          <th class="p-0 align-middle plittable-td bg-info-subtle" colSpan="1">Support</th> 
                          <th class="p-0 align-middle plittable-td bg-info-subtle">&nbsp;</th> 
                          <th class="p-0 align-middle plittable-td bg-info-subtle">&nbsp;</th> 
                          <th class="p-0 align-middle plittable-td bg-info-subtle">&nbsp;</th> 
                          <th class="p-0 align-middle plittable-td bg-info-subtle">&nbsp;</th> 
                          <th class="p-0 align-middle plittable-td bg-info-subtle">&nbsp;</th> 
                        </tr>
                      </thead>
                      <tbody>
                    {
                      piltData!==null&&piltData[rowindex*3+colindex]!==null&&piltData[rowindex*3+colindex]!==undefined&&
                        piltData[rowindex*3+colindex].map((planet,planetIndex) => (
                          <tr class="m-0 p-0">
                            <td class="m-0 p-0 pt-1 ps-2 text-start">{planet[0][0]}</td>
                            <td class="m-0 p-0 pt-1 ps-2 text-start" style={getStyle(planet,1)}>{planet[1][0]}</td>
                            <td class="m-0 p-0 pt-1 text-center" style={getStyle(planet,2)}>{planet[2][0]}</td>
                            <td class="m-0 p-0 pt-1 text-center" style={getStyle(planet,3)}>{getValue(planet,3,0)}</td>
                            <td class="m-0 p-0 pt-1 text-center" style={getStyle(planet,4)}>{getValue(planet,4,0)}</td>
                            <td class="m-0 p-0 pt-1 text-center" style={getStyle(planet,5)}>{getValue(planet,5,0)}</td>
                            <td class="m-0 p-0 pt-1 text-center" style={getStyle(planet,6)}>{getValue(planet,6,0)}</td>
                            <td class="m-0 p-0 pt-1 text-center" style={getStyle(planet,7)}>{getValue(planet,7,0)}</td>
                            <td class="m-0 p-0 pt-1 text-center" style={getStyle(planet,8)}>{getValue(planet,8,0)}</td>
                          </tr>  
                      ))}
                      </tbody>
                    </table>
                  </Col>
                  ))}
                </Row> 
                ))}

              </Col>
              <Col xs={0} lg={3} className="m-0 p-0 text-center noprint">
                <Row id="time4" className="m-0 p-0 ">
                  <Col xs={12} lg={12} className="m-0 p-0 pt-1 pb-1">
                      &nbsp;
                  </Col>
                </Row>      
                <Row id="timechart2" className="m-0 p-0">
                  <Col xs={12} lg={12} className="m-0 p-1 pb-2 text-center">
                    <table class="table table-bordered table-hover align-middle caption-top p-0 m-0 text-center TableFont11">
                      <thead>
                        <tr class="m-0 p-0">
                          <th class="m-0 plittable-td">&nbsp;</th>
                          <th class="m-0 plittable-td">All</th>
                          <th class="m-0 plittable-td">Planet</th>
                          <th class="m-0 plittable-td">Sign</th>
                          <th class="m-0 plittable-td">Support</th>
                        </tr>  
                      </thead>
                      <tbody class="m-0 p-0">
                      {favorloop.map((value, index) => (
                        <tr class="m-0 p-0">
                          <td class={" m-0 p-1 text-start plittable-td"}>{value}</td>
                          <td class="m-0 p-1 plittable-td"><input class="form-check-input" style={{scale:2}} type="checkbox" value="" id={"all"+index} onChange={(e)=>handleChange(index,0,e)}/></td>
                          <td class="m-0 p-1 plittable-td"><input class="form-check-input" style={{scale:2}} type="checkbox" value="" id={"PL"+index} onChange={(e)=>handleChange(index,1,e)}/></td>
                          <td class="m-0 p-1 plittable-td"><input class="form-check-input" style={{scale:2}} type="checkbox" value="" id={"SG"+index} onChange={(e)=>handleChange(index,2,e)}/></td>
                          <td class="m-0 p-1 plittable-td"><input class="form-check-input" style={{scale:2}} type="checkbox" value="" id={"SU"+index} onChange={(e)=>handleChange(index,3,e)}/></td>
                        </tr>
                      ))}  
                      </tbody>
                    </table>
                  </Col>
                </Row>

                <Row id="timechart2" className="m-0 p-0">
                  <Col xs={12} lg={12} className="m-0 p-1 pb-2 text-center">
                    <table class="table table-bordered table-hover align-middle caption-top p-0 m-0 text-center TableFont11">
                      <thead>
                        <tr class="m-0 p-0">
                          <th class="m-0 plittable-td" colSpan="2">Planet</th>
                          <th class="m-0 plittable-td">Order</th>
                          <th class="m-0 plittable-td">All</th>
                          <th class="m-0 plittable-td">Planet</th>
                          <th class="m-0 plittable-td">Sign</th>
                          <th class="m-0 plittable-td">Support</th>
                        </tr>  
                      </thead>
                      <tbody class="m-0 p-0">
                      {planetloop.map((value, index) => (
                        <tr class="m-0 p-0">
                          
                        { piltData[index] === undefined || piltData[index][0]===undefined || piltData[index][0][1]===undefined || piltData[index][0][1][1]==="" || piltData[index][0][1][1]===undefined ?
                          <>
                            <td class={" m-0 p-1 ps-2 text-start plittable-td"} >{value}</td>
                            <td class={" m-0 p-1 ps-2 text-start plittable-td"}>&nbsp;</td>
                          </>
                          :
                          <>
                            <td class={" m-0 p-1 ps-2 text-start plittable-td"} style={{'background-color':eventData.allPlanetCategory[piltData[index][0][1][1]][2], 'color':eventData.allPlanetCategory[piltData[index][0][1][1]][3]}} >{value}</td>
                            <td class={" m-0 p-1 ps-2 text-start plittable-td"}>{eventData.allPlanetCategory[piltData[index][0][1][1]][1]}</td>
                          </>
                        }

                        { eventData!==null && eventData.userEvent!==null && eventData.userEvent.planetOrder!==null
                            &eventData.userEvent.planetOrder!==undefined?  
                          <td class={" m-0 p-1 text-center plittable-td"} >{eventData.userEvent.planetOrder.split(",")[planetOrderloop[index]-1]==="0"?"":eventData.userEvent.planetOrder.split(",")[planetOrderloop[index]-1]}</td>
                          :
                          <td class={" m-0 p-1 text-center plittable-td"} ></td>
                        }
                          <td class="m-0 p-1 plittable-td"><input class="form-check-input" style={{scale:2}} type="checkbox" value="" id={"allp"+index} onChange={(e)=>handlePlanetChange(index,0,e)}/></td>
                          <td class="m-0 p-1 plittable-td"><input class="form-check-input" style={{scale:2}} type="checkbox" value="" id={"PLp"+index} onChange={(e)=>handlePlanetChange(index,1,e)}/></td>
                          <td class="m-0 p-1 plittable-td"><input class="form-check-input" style={{scale:2}} type="checkbox" value="" id={"SGp"+index} onChange={(e)=>handlePlanetChange(index,2,e)}/></td>
                          <td class="m-0 p-1 plittable-td"><input class="form-check-input" style={{scale:2}} type="checkbox" value="" id={"SUp"+index} onChange={(e)=>handlePlanetChange(index,3,e)}/></td>
                        </tr>
                      ))}  
                      </tbody>
                    </table>
                  </Col>
                </Row>

                <Row id="timechart2" className="m-0 p-0">
                  <Col xs={12} lg={12} className="m-0 p-1 pb-2 text-center">
                    <button type="button" class="btn btn-outline-primary" onClick={handleClear}>Remove All</button>
                  </Col>
                </Row>


              </Col>
            </Row>

          </Col>
        </Row>
      </Collapse>
    }    
  </>
   );
}